export const getCompletedPersonService = ({ markers = [], user }) => {
  const mainIds = user?.data?.main_id ?? [];

  const total = mainIds.length;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  const completedObj = [];

  markers.forEach((item) => {
    if (!item.last_to) return;

    if (!mainIds.includes(item.id)) return;

    const [, month, year] = item.last_to.split(".").map(Number);

    if (year === currentYear && month === currentMonth) {
      if (!completedObj.includes(item.id)) {
        completedObj.push(item.id);
      }
    }
  });

  const completed = completedObj.length;
  const remains = total - completed;

  return {
    total,
    completed,
    remains,
    completedObj,
  };
};
